var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.preparedBanners.length
    ? _c(
        "section",
        {
          staticClass: "lpu-banners",
          class: { "mx-n2": _setup.isMobile },
          attrs: { "data-qa": "branding_banners_section" },
        },
        [
          _setup.isMobile
            ? _c(_setup.CoreSwiper, {
                staticClass: "px-2",
                attrs: {
                  "slides-per-view": 1,
                  "has-pagination": _setup.preparedBanners.length > 1,
                  "placeholder-min-height": _setup.bannerPlaceholderHeight,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "slides",
                      fn: function ({ slideAttrs }) {
                        return _vm._l(
                          _setup.preparedBanners,
                          function (banner, index) {
                            return _c(
                              "div",
                              _vm._b({ key: index }, "div", slideAttrs, false),
                              [
                                _c(_setup.BannerItem, {
                                  attrs: { src: banner.mobileSrc },
                                }),
                              ],
                              1
                            )
                          }
                        )
                      },
                    },
                  ],
                  null,
                  false,
                  1090279069
                ),
              })
            : _c(
                "div",
                { staticClass: "lpu-banners__list ga-4" },
                _vm._l(_setup.preparedBanners, function (banner, index) {
                  return _c(_setup.BannerItem, {
                    key: index,
                    attrs: { src: banner.desktopSrc },
                  })
                }),
                1
              ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }